export default __webpack_public_path__ + "static/media/contact-img-1.92ee95e1.png";